// /trust — PRD 16 C2, the data-collection ledger.
//
// A ROOT route, deliberately not a child of `_shell`. Per PRD 16 decision D2,
// Tier C lives on a surface separate from the analytics dashboard, and the
// consequence recorded with that decision is that a security reviewer or a
// program office can be shown this "before purchase, without an account on
// the main surface". The screen renders a build-time constant and reads no
// tenant data, so there is nothing on it an org gate would protect.

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { DataLedgerScreen } from "../screens/trust";

export const trustRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/trust",
  component: DataLedgerScreen,
});
